import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from './components/Navbar';
import About from './sections/About';
import Portfolio from './sections/Portfolio';
import './App.css';
import PortfolioCarousel from './sections/PortfolioCarousel';
import BookSessionForm from "./sections/BookSessionForm";
import WhatsAppButton from "./components/WhatsAppButton";
import BookSessionTodayButton from "./components/BookSessionTodayButton";
import Footer from "./components/Footer";
import Pricing from "./components/Pricing";
import ScrollToHash from './components/ScrollToHash';
function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={
            <>
              <Navbar />
              <PortfolioCarousel />
              <About />
              <Portfolio />
              <BookSessionForm />
              <BookSessionTodayButton />
              <WhatsAppButton />
              <Footer />
              <ScrollToHash />
            </>
          }
        />
        {/* Pricing Page */}
        <Route path="/pricing"  element={<Pricing />}/>
        {/* <Route path="/special-offer" element={<Pricing />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
